import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { QRStickerPurchaseCard } from "../components/QRStickerPurchaseCard";

/**
 * QRLabels — single home for everything sticker-related.
 *
 * Replaces the old "Settings" entry from the Profile screen. Houses the
 * free print-your-own flow AND the (currently mocked) paid sticker SKUs
 * so the user has one obvious place to come for QR supplies.
 */
const QRLabels = () => {
  const navigate = useNavigate();

  return (
    <div className="px-5 pt-6 pb-8" data-testid="qr-labels-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="qr-labels-back-btn"
        className="text-sm text-[#4F5D75] hover:text-[#2D3142] flex items-center gap-2 mb-4"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8A93A6]">
          Supplies
        </div>
        <h1 className="font-heading text-3xl font-bold text-[#2D3142] mt-1">
          QR Labels
        </h1>
        <p className="text-sm text-[#4F5D75] mt-2 max-w-md leading-relaxed">
          Print your own QFresh stickers at home — or order a permanent,
          dishwasher-safe pack shipped to your door.
        </p>
      </motion.div>

      <QRStickerPurchaseCard />
    </div>
  );
};

export default QRLabels;
